import { ColumnFiltersState } from '@tanstack/react-table';

const useTableState = (tableName: string) => {
	const setPageIndex = (pageIndex: number) => {
		sessionStorage.setItem(`PAGE_INDEX_${tableName}`, pageIndex.toLocaleString());
	};

	const setPageSize = (pageSize: number) => {
		sessionStorage.setItem(`PAGE_SIZE_${tableName}`, pageSize.toLocaleString());
	};

	const setFilters = (filters: ColumnFiltersState) => {
		sessionStorage.setItem(`FILTERS_${tableName}`, JSON.stringify(filters));
	};

	return {
		setPageIndex,
		setPageSize,
		setFilters,
		pageIndex: parseInt(sessionStorage.getItem(`PAGE_INDEX_${tableName}`) || '0', 10),
		pageSize: parseInt(sessionStorage.getItem(`PAGE_SIZE_${tableName}`) || '50', 10),
		filters: JSON.parse(
			sessionStorage.getItem(`FILTERS_${tableName}`) || '[]',
		) as ColumnFiltersState,
	};
};

export default useTableState;
